<template>
    <div class="ui footer segment">
        <div class="ui center aligned container">
            <div class="ui horizontal inverted small divided list">
                <p>
                    Copyright © {{ current_year }} Genki Inc. All rights reserved
                </p>
            </div>
        </div>
        <div class="ui divider"></div>
        <div class="ui horizontal list" v-if="host != 'forever.tw568.com'">
            <div class="item">
                <img src="/images/tw568_logo.png" style="height: 50px;">
            </div>
            <div class="item">
                <img src="/images/neuron_logo.png" style="height: 50px;">
            </div>
            <div class="item">
                <img src="/images/by_express_logo.jpg" style="height: 50px;">
            </div>
            <div class="item">
                <img src="/images/t_cat_logo.jpg" style="height: 50px;">
            </div>
            <div class="item">
                <img src="/images/hct_logo.png" style="height: 50px;">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
    },
    data() {
        return {
            host: window.location.hostname,
        }
    },
    computed: {
        current_year() {
            return (new Date()).getFullYear()
        }
    }
}
</script>
